<template>
    <div :class="['header_wrap',{'mob-header_wrap':!isPc}]" :style="cssVars">
        <div :class="['header-container', { 'mob-header-container': !isPc }]">
            <div :class="['background-logo', { 'mob-background-logo': !isPc }]" @click="refreshPage"></div>
            <div v-if="isPc" class="nav-wrapper">
                <div v-for="item in headBtnList" :key="item.button_type" :class="{ 'nav-item-inactive': true }"
                    @click="handleClick(item)">
                    <span class="nav-title">{{item.button_text }}</span>
                </div>
            </div>
            <div v-else ref="mobileMenu" class="mobile-menu">
                <div class="menu-icon" @click="toggleMenu"></div>
                <div v-show="isMenuOpen" class="dropdown-menu">
                    <div v-for="item in headBtnList" :key="item.button_type" class="menu-item" @click="handleMobClick(item)">
                        {{ item.button_text }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { dataReport } from '../../../../../../utils/report';
export default {
    props: {
        headInfo: {
            type: Array,
            default: () => ([])
        },
        isPc: {
            type: Boolean,
            default: true
        },
        headBtnList: {
            type: Array,
            default: () => ([])
        },
    },
    data() {
        return {
            isMenuOpen: false,
            defaultIcon: 'https://coss-platform.fenqile.com/platformresource200/M00/ex/20251124164309-3300c378-14ef-45ee-bfb4-4770dffe3944.png',
            scrollIcon:'https://coss-platform.fenqile.com/platformresource200/M00/ex/20251124164340-059e1cf6-2b71-4485-b91b-1ab4060602de.png',
            logoDefault: '',
            logoScrolled: ''
        };
    },
    methods: {
        toggleMenu(e) {
            dataReport({
                hottag: 'FQL_HOME_MOB_MENU_CLICK',
                eventPosName: '分期乐移动端首页菜单点击',
                eventType: 2, //点击菜单
            })
            e.stopPropagation();
            this.isMenuOpen = !this.isMenuOpen;
        },
        refreshPage() {
            window.location.reload(); // 刷新当前页面
            dataReport({
                hottag: 'FQL_HOME_WEB_REFRESH',
                eventPosName: '分期乐web首页刷新',
                eventType: 2, //点击刷新
            })
        },
        handleClick(item) {
            // 获取当前项的链接
            const targetLink = item.button_link;
            // 若链接存在则跳转
            if (targetLink) {
                dataReport({
                    hottag: 'FQL_HOME_WEB_NAV_CLICK',
                    eventPosName: `分期乐web首页导航点击`,
                    eventType: 2, //点击导航
                }, { targetLink })
                window.location.href = targetLink;
            }
        },
        handleMobClick(item) {
            // 获取当前项的链接
            const targetLink = item.button_link;
            // 若链接存在则跳转
            if (targetLink) {
                dataReport({
                    hottag: 'FQL_HOME_MOB_NAV_CLICK',
                    eventPosName: `分期乐移动端首页导航点击`,
                    eventType: 2, //点击导航
                }, { targetLink })
                window.location.href = targetLink;
            }
        },
        handleScroll() {
            const header = document.querySelector('.header_wrap');
            if (window.scrollY > 10) { // 滚动超过10px时触发
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }
        },
        handleDocumentClick(e) {
            // 检查点击事件是否发生在菜单内部
            if (this.isMenuOpen && this.$refs.mobileMenu && !this.$refs.mobileMenu.contains(e.target)) {
                this.isMenuOpen = false;
            }
        }
    },
    computed: {
        // 新增：CSS 变量计算属性
        cssVars() {
            return {
                // 定义 CSS 变量（--开头），值为组件数据
                '--logo-default': `url('${this.logoDefault}')`,
                '--logo-scrolled': `url('${this.logoScrolled}')`,
                '--default-icon': `url('${this.defaultIcon}')`,
                '--scroll-icon': `url('${this.scrollIcon}')`
            };
        }
    },
    watch: {
        headInfo: {
            handler(newVal) {
                if (newVal.length) {
                    const data = newVal[0];
                    this.logoDefault = data.logo_default;
                    this.logoScrolled = data.logo_scrolled;
                }
            },
            deep: true
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        document.addEventListener('click', this.handleDocumentClick);
        document.addEventListener('touchstart', this.handleDocumentClick);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
        document.removeEventListener('click', this.handleDocumentClick);
        document.removeEventListener('touchstart', this.handleDocumentClick);
    }

};
</script>

<style scoped>
.header_wrap {
    z-index: 1000;
    position: fixed;
    top: 0;
    height: 74px;
    transition: all 0.5s ease;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: transparent;
}

.mob-header_wrap {
    height: 60px;
}

.header_wrap.scrolled {
    background-color: rgb(255, 255, 255);
}

.header_wrap.scrolled .background-logo {
    background-image: var(--logo-scrolled);
}


.header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    max-width: 1200px;
    /* 最大宽度限制 */
    width: 100%;
    height: 74px;
}

.mob-header-container {
    padding: 0 16px;
    height: 44px;
}

.background-logo {
    width: 109.7px;
    height: 54.36px;
    background-image: var(--logo-default);
    background-size: contain;
    cursor: pointer;
    background-repeat: no-repeat;
    /* 禁止图片重复 */
    background-position: left center;
    /* 左对齐，避免右侧留白 */
}

.mob-background-logo {
    width: 70px;
    height: 35px;
}

.nav-wrapper {
    /* width: 257px; */
    height: 72px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.nav-item-inactive {
    box-sizing: content-box;
    height: 100%;
    min-width: 136px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.header_wrap.scrolled .nav-title {
    color: rgb(47, 47, 47);
}

.nav-item-inactive:hover {
    border-bottom: 4px solid #fff;
}

.header_wrap.scrolled .nav-item-inactive:hover {
    border-bottom: 4px solid rgb(64, 122, 255);
}

.header_wrap.scrolled .nav-item-inactive.active .nav-title {
    color: rgb(64, 122, 255);
    font-weight: 500;
}

.nav-title {
    cursor: pointer;
    color: #fff;
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: 400;
}

.mobile-menu {
    position: relative;
}

.menu-icon {
    width: 28px;
    height: 28px;
    cursor: pointer;
    background-image: var(--default-icon);
    background-repeat: no-repeat;
    background-size: contain;
}

.header_wrap.scrolled .menu-icon {
    background-image: var(--scroll-icon);
}

.dropdown-menu {
    position: absolute;
    top: 35px;
    right: 0;
    background-color: white;
    border-radius: 4px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 1001;
}

.menu-item {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 136px;
    height: 48px;
    cursor: pointer;
    color: #414141;
    font-size: 14px;
}

.menu-item:hover {
    background-color: #f5f5f5;
}
</style>